module.exports = __webpack_public_path__ + "img/detail-collapsed-long.52816c4a.svg";